import React, { useEffect, useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
    AiOutlineDashboard,
    AiOutlineBgColors,
    AiFillBank,
    AiOutlinePullRequest,
    AiTwotoneHome,
    AiFillReconciliation,
    AiFillPropertySafety,
    AiFillMessage,
    AiOutlineRollback,
    AiFillVideoCamera,
    AiOutlineAlert,
    AiOutlineProduct,
    AiOutlineUser,
    AiOutlineQuestion,
    AiFillUnlock,
    AiOutlineHistory,
    AiFillEnvironment,
} from "react-icons/ai";
import { AiOutlineAppstore } from 'react-icons/ai';
import { MdOutlineWorkOutline } from 'react-icons/md';
import { RiNotification2Line, RiCommunityLine } from 'react-icons/ri';
import { BiCategoryAlt } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { IoIosNotifications } from "react-icons/io";
import { Layout, Menu, Grid, theme } from "antd";

// Import images
import logo from "../assets/images/logo.jpg";
import smallLogo from "../assets/images/logo1.jpg";
// import userImage from "../assets/images/logo.png";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const MainLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const screens = useBreakpoint();

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setCollapsed(true);
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // Initial check
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleLogout = () => {
        toast.success("You are logged out");
        setTimeout(() => {
            navigate("/");
        }, 1000);
    };

    const handleMenuClick = ({ key }) => {
        navigate(key); // Navigate to the selected menu route
    };

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <Layout>
            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                className="sider"
                breakpoint="md"
                collapsedWidth="80"
            >
                <div className="logo text-center py-3">
                    <img
                        src={collapsed ? smallLogo : logo}
                        alt="Logo"
                        className="logo-img rounded-3"
                        style={{
                            width: collapsed ? "50px" : "90px",
                            transition: "width 0.3s",
                        }}
                    />
                </div>
                <Menu
                    theme="dark"
                    mode="inline"
                    defaultSelectedKeys={["/admin"]}
                    onClick={handleMenuClick}
                    items={[
                        {
                            key: "",
                            icon: <AiOutlineDashboard className="fs-4" />,
                            label: "Dashboard",
                        },
                        {
                            key: "All-Users",
                            icon: <AiOutlineUser className="fs-4" />,
                            label: "All Users",
                        },
                        {
                            key: "Tour-In-Person",
                            icon: <AiOutlinePullRequest className="fs-4" />,
                            label: "InPersonReq",
                        },
                        {
                            key: "Tour-Via-VideoChat",
                            icon: <AiOutlinePullRequest className="fs-4" />,
                            label: "TourVideoChatReq",
                        },
                        {
                            key: "Add-category-manager",
                            icon: <BiCategoryAlt className="fs-4" />,
                            label: "Add Category",
                        },
                        {
                            key: "Main-sub-category",
                            icon: <AiOutlineBgColors className="fs-4" />,
                            label: "MainSubCategory",
                        },
                        {
                            key: "AddNewproduct",
                            icon: <AiOutlineProduct className="fs-4" />,
                            label: "Add Products",
                        },
                        {
                            key: "All-Roles",
                            icon: <AiOutlineUser className="fs-4" />,
                            label: "All Roles",
                        },
                        {
                            key: "Add-Blogs",
                            icon: <AiFillUnlock className="fs-4" />,
                            label: "Add-Blogs",
                        },
                        {
                            key: "Success-Stories",
                            icon: <AiOutlineHistory className="fs-4" />,
                            label: "Add Exective Leaders",
                        },
                        {
                            key: "Success-Story-Manager",
                            icon: <AiOutlineHistory className="fs-4" />,
                            label: "Admin-Success-story",
                        },
                        {
                            key: "UpComming-Events",
                            icon: <AiFillEnvironment className="fs-4" />,
                            label: "UpComming-Events",
                        },
                        {
                            key: "Registered-Event-Req",
                            icon: <AiFillEnvironment className="fs-4" />,
                            label: "Registered-Event-Req",
                        },
                        {
                            key: "Create-Faqs",
                            icon: <AiFillUnlock className="fs-4" />,
                            label: "Create-Faqs",
                        },
                        {
                            key: "Add-Home-Locations",
                            icon: <AiTwotoneHome className="fs-4" />,
                            label: "Home-Locations",
                        },
                        {
                            key: "Add-Questions",
                            icon: <AiOutlineQuestion className="fs-4" />,
                            label: "Add-Questions",
                        },
                        {
                            key: "whats-new",
                            icon: <AiOutlineAlert className="fs-4" />,
                            label: "Whats New"
                        },
                    ]}
                />
            </Sider>
            <Layout className="site-layout">
                <Header
                    className="sticky-top d-flex justify-content-between ps-1 pe-5 header"
                    style={{ color: "white", lineHeight: "10px" }}
                >
                    {React.createElement(
                        collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                        {
                            className: "trigger",
                            onClick: () => setCollapsed(!collapsed),
                        }
                    )}

                    <div className="d-flex gap-4 align-items-center">
                        <div className="position-relative">
                            <IoIosNotifications className="fs-4" />
                            <span className="badge bg-warning rounded-circle p-1 position-absolute">
                                3
                            </span>
                        </div>

                        <div className="d-flex gap-3 align-items-center dropdown">
                            <div>
                                {/* <img
                                    width={32}
                                    height={32}
                                    src={userImage}
                                    className="object-fit-contain"
                                    alt="User"
                                /> */}
                            </div>
                            <div
                                role="button"
                                id="dropdownMenuLink"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {!screens.xs && (
                                    <div className="d-flex flex-column">
                                        <h5 className="mb-0">Admin</h5>
                                        <span className="m-0">admin@example.com</span>
                                    </div>
                                )}
                            </div>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                <li>
                                    <Link
                                        className="dropdown-item py-1 mb-1"
                                        style={{ height: "auto", lineHeight: "20px" }}
                                    >
                                        View Profile
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className="dropdown-item py-1 mb-1"
                                        style={{ height: "auto", lineHeight: "20px" }}
                                        onClick={handleLogout}
                                    >
                                        Sign out
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Header>

                <Content
                    style={{
                        background: colorBgContainer,
                        overflowY: "auto",
                    }}
                >
                    <ToastContainer
                        position="top-right"
                        autoClose={250}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        theme="light"
                    />
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default MainLayout;

